import { Nullable } from "@/types/common";
import { Image, ViewMode } from "@/types/thread";
import { getDisplayedTimeAgo } from "@/utils/date";
import Feedback from "../Feedback";
import ReportButton from "../ReportButton";
// import UsePrompt from "../UsePrompt";
import ViewModeToggle from "../../GenInputs/Controls/ViewModeToggle";
import DeleteGeneration from "../DeleteGeneration";

interface GenerationControlsProps {
  id: number;
  threadUUID?: string;
  createdAt: string;
  isPrivate: boolean;
  images: Image[];
  viewMode: ViewMode;
  feedbackRating?: Nullable<string>;
  feedbackComment?: Nullable<string>;
  feedbackTooSlow?: boolean;
  feedbackWrongOutput?: boolean;
}

const GenerationControls: React.FC<GenerationControlsProps> = ({
  id,
  threadUUID,
  createdAt,
  isPrivate,
  images,
  viewMode,
  feedbackRating,
  feedbackComment,
  feedbackTooSlow,
  feedbackWrongOutput,
}) => {
  return (
    <div className="tw:flex tw:items-center tw:justify-between">
      <div className="tw:flex tw:items-center tw:gap-3">
        {isPrivate ? (
          <Feedback
            generationId={id}
            feedbackRating={feedbackRating}
            feedbackComment={feedbackComment}
            existingFeedbackTooSlow={feedbackTooSlow}
            existingFeedbackWrongOutput={feedbackWrongOutput}
          />
        ) : (
          <>
            {/* {!isFeed && <UsePrompt prompt={props.textPrompt} />} */}
            <ReportButton
              url={`${process.env.NEXT_PUBLIC_BASE_URL}/idea/${threadUUID}`}
              generationUrls={images.map((image) => image.url)}
            />
          </>
        )}
      </div>
      <div className="tw:flex tw:items-center tw:gap-3">
        <p className="tw:text-xxs tw:text-[#757575]">
          {getDisplayedTimeAgo(createdAt)}
        </p>
        <ViewModeToggle
          generationViewMode={viewMode}
          generationId={id}
          scale={0.88}
          displayOnly={!isPrivate}
        />
        {isPrivate && <DeleteGeneration id={id} />}
      </div>
    </div>
  );
};

export default GenerationControls;
